import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import type Ajax from "cc-frontend/services/ajax"
import ENV from "../config/environment"

export default class CardStackAdapter extends EmberObject {
  @service declare ajax: Ajax

  find(ids: string[] = []) {
    return get(this, "ajax").requestFromAdapter(ENV.API_ROOT + "/card_stacks/" + ids.join(","))
  }
}
